module.exports = __webpack_public_path__ + "img/2.c2619609.svg";